import Ajv from "ajv";

export default {
  mask_guid(guid) {
    if (!guid) return;
    let start = 5;
    let end = 30;
    let a = guid.substring(0, start);
    let b = guid.substring(start, end).replace(/[^-]/gi, "∗");
    let c = guid.substring(end);
    return a + b + c;
  },
  guid() {
    function _p8(s) {
      var p = (Math.random().toString(16) + "000000000").substring(2, 10);
      return s ? "-" + p.substring(0, 4) + "-" + p.substring(4, 8) : p;
    }
    return _p8() + _p8(true) + _p8(true) + _p8();
  },
  copy(obj) {
    return JSON.parse(JSON.stringify(obj));
  },
  get_local_datetime(datetime) {
    if (!(datetime instanceof Date)) return datetime;
    let current = new Date();
    let local_now = new Date(
      datetime.getTime() - current.getTimezoneOffset() * 60000
    ).toISOString();
    let date_time = {
      date: local_now.substring(0, 10),
      time: local_now.substring(11, 19),
      offset: -1 * current.getTimezoneOffset(),
    };
    return date_time;
  },
  zeroPad(num, places) {
    return String(num).padStart(places, "0");
  },
  time_offset(offset) {
    let sign = "+";
    if (offset < 0) sign = "-";
    offset = Math.abs(offset);
    return `${sign}${this.zeroPad(Math.floor(offset / 60), 2)}${this.zeroPad(
      offset % 60,
      2
    )}`;
  },
  get_datetime(local_datetime) {
    let offset = this.time_offset(local_datetime?.offset);
    let strdate = `${local_datetime?.date}T${local_datetime?.time}${offset}`;
    return new Date(strdate);
  },
  millis_to_time(m) {
    let millis = m % 1000;
    let seconds = Math.floor(m / 1000);
    let hours = Math.floor(seconds / 3600);
    seconds = seconds % 3600;
    let minutes = Math.floor(seconds / 60);
    seconds = seconds % 60;
    return { hours: hours, minutes: minutes, seconds: seconds, millis: millis };
  },
  build_path_data(url, params) {
    const fetch_url = new URL("http://test" + url);
    Object.keys(params).forEach((k) => {
      if (k in params && !(params[k] === "" || params[k] === null)) {
        fetch_url.searchParams.append(k, params[k]);
      }
    });
    let path = fetch_url.pathname + fetch_url.search + fetch_url.hash;
    return path;
  },
  build_as_query_path_data(params) {
    const fetch_url = new URL("http://test");
    Object.keys(params).forEach((k) => {
      if (k in params && !(params[k] === "" || params[k] === null)) {
        fetch_url.searchParams.append(k, params[k]);
      }
    });
    return fetch_url.search;
  },
  remove_from_router(router_query, param_name) {
    let query = router_query ? this.T.copy(router_query) : {};
    let mod = false;
    if (param_name in query) {
      delete query[param_name];
      mod = true;
    }
    return { mod: mod, query: query };
  },
  validate_schema(schema, data) {
    const ajv = new Ajv({ allErrors: true });
    const validate = ajv.compile(schema);
    const v = validate(data);
    return [v, validate];
  },
  resolve_schema_ref(schema, ref) {
    // console.log(schema);
    if (ref && ref?.startsWith("#/")) {
      let parts = ref.split("/");
      // console.log(parts);
      let obj = schema;
      let i = 1;
      while (obj && i < parts.length) {
        obj = this.copy(obj[parts[i]]);
        // console.log(obj, parts[i], i);
        i++;
      }
      // console.log(obj);
      obj.definitions = this.copy(schema.definitions);
      return obj;
    }
    return null;
  },
  remove_port(url) {
    let U = new URL(url);
    if (U.protocol == "https:") {
      U.port = 443;
      return U.toString();
    } else if (U.protocol == "http:") {
      U.port = 80;
      return U.toString();
    }
    return url;
  },
  get_referer() {
    const location = window.location;
    const urlPieces = [
      location.protocol,
      "//",
      location.host,
      location.pathname,
    ];
    return urlPieces.join("");
  },
  diff_array(arr1, arr2) {
    let difference = arr1
      .filter((x) => !arr2.includes(x))
      .concat(arr2.filter((x) => !arr1.includes(x)));
    // symmertic difference
    return difference;
  },
  sort_by_preorder(arr, preorder) {
    arr.sort(function (a, b) {
      return preorder.indexOf(a) - preorder.indexOf(b);
    });
  },
  get_local_timezone() {
    try {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (e) {
      return "America/New_York";
    }
  },
  get_do_not_track() {
    if (navigator.doNotTrack) {
      return navigator.doNotTrack;
    } else if (navigator.msDoNotTrack) {
      return navigator.msDoNotTrack;
    } else if (window.doNotTrack) {
      return window.doNotTrack;
    } else {
      return "unknown";
    }
  },
  get_touch_support() {
    return (
      "ontouchstart" in window ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0
    );
  },
  get_platform() {
    return navigator?.userAgentData?.platform || navigator?.platform;
  },
  get_browser_fingerprint() {
    const user_agent = navigator.userAgent;
    const screen_resolution = `${screen.width}x${screen.height}`;
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const language = navigator.language || navigator.userLanguage;
    const cookie_enabled = navigator.cookieEnabled;
    const platform = this.get_platform();
    const do_not_track = this.get_do_not_track();
    const touch_support = this.get_touch_support();
    let session_storage = null;
    let local_storage = null;
    try {
      session_storage = !!window.sessionStorage;
    } catch (e) {}
    try {
      local_storage = !!window.localStorage;
    } catch (e) {}
    return {
      user_agent,
      screen_resolution,
      timeZone,
      language,
      session_storage,
      local_storage,
      cookie_enabled,
      do_not_track,
      touch_support,
      platform,
    };
  },
  async hash_me(fingerprint) {
    const hash = await crypto.subtle.digest(
      "SHA-256",
      new TextEncoder().encode(JSON.stringify(fingerprint))
    );
    return Array.from(new Uint8Array(hash))
      .map((b) => b.toString(16).padStart(2, "0"))
      .join("");
  },
};
